import { getCustomProps } from '../forms'
import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface IdentificationType {
  id?: string
  name: string
  code: string
  countryId: string
}

export async function getIdentificationTypes(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  let where = []
  if (search) {
    where.push(
      `CONCAT(countries.name, identification_types.name, identification_types.code) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN identification_types.code ~ '^[0-9]+$' THEN CAST(identification_types.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, identification_types.code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN identification_types.code ~ '^[0-9]+$' THEN CAST(identification_types.code AS NUMERIC) ELSE NULL END), identification_types.code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_identification_types'],
    fields: [
      'identification_types.id',
      'identification_types.code',
      'identification_types.name',
      'countries.name as country',
      'identification_types.updated_at'
    ],
    join: ['INNER JOIN countries ON identification_types.country_id = countries.id'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getIdentificationType(
  id: string
): Promise<IdentificationType> {
  const data = await getData<any>({
    tables: ['pg_identification_types'],
    fields: ['id', 'code', 'name', 'country_id as countryId', 'custom_fields as custom'],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createIdentificationType(
  data: IdentificationType
): Promise<boolean> {
  const response: any = await http.post('country/identification-types', {
    countryId: data.countryId,
    name: data.name,
    code: data.code,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateIdentificationType(
  data: IdentificationType,
  id: string
): Promise<boolean> {
  const response: any = await http.put('country/identification-types/' + id, {
    countryId: data.countryId,
    name: data.name,
    code: data.code,
    customFields: {
      ...getCustomProps(data)
    }
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteIdentificationType(id: string): Promise<boolean> {
  const response: any = await http.delete('country/identification-types/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
